import * as React from 'react';
import {connect} from 'react-redux';

import PropTypes from 'prop-types';

import {DashGrid} from '../../dash-grid';
import * as selectors from '../../dashboard-selectors';

import styles from './dashboard-pane-left.module.css';

const mapStateToProps = function (state) {
    return {
        sidebarIsSnappedOpen: selectors.getIsSidebarSnappedOpen(state),
    };
};

export class DashboardPaneLeftComponent extends React.Component {
    static propTypes = {
        sidebarIsSnappedOpen: PropTypes.bool.isRequired,
    };

    render() {
        return (
            <div className={styles.container}>
                <DashGrid preventScrolling={this.props.sidebarIsSnappedOpen} />
            </div>
        );
    }
}

export const DashboardPaneLeft = connect(mapStateToProps)(DashboardPaneLeftComponent);
